var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6295 10.5458V3.13134C23.6295 1.60904 22.3909 0.370483 20.8686 0.370483H2.76077C1.23847 0.370483 0 1.60904 0 3.13134V14.3864C0 15.9087 1.23847 17.1473 2.76077 17.1473H9.92062C10.8763 20.3154 13.8212 22.6295 17.2969 22.6295C21.5444 22.6295 24.9999 19.1739 24.9999 14.9264C25 13.3001 24.493 11.7904 23.6295 10.5458ZM12.9164 8.59381H1.70067V6.18286H21.9288V8.77554C20.6387 7.80163 19.0342 7.22335 17.2969 7.22335C15.6708 7.22327 14.1609 7.73025 12.9164 8.59381ZM2.76077 2.07116H20.8686C21.4532 2.07116 21.9288 2.54675 21.9288 3.13134V4.48219H1.70067V3.13134C1.70067 2.54675 2.17626 2.07116 2.76077 2.07116ZM2.76077 15.4466C2.17626 15.4466 1.70067 14.971 1.70067 14.3864V10.2945H11.146C10.1721 11.5845 9.59385 13.1891 9.59385 14.9264C9.59385 15.1013 9.60025 15.2746 9.61178 15.4467H2.76077V15.4466ZM17.297 20.9287C13.9872 20.9287 11.2945 18.2361 11.2945 14.9263C11.2945 11.6166 13.9872 8.92394 17.297 8.92394C20.6066 8.92394 23.2993 11.6166 23.2993 14.9263C23.2993 18.2361 20.6066 20.9287 17.297 20.9287Z",
    fill: "#FFBB38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1853 12.7054C12.7157 12.7054 12.335 13.0862 12.335 13.5558V16.2969C12.335 16.7665 12.7157 17.1472 13.1853 17.1472H21.4086C21.8782 17.1472 22.259 16.7665 22.259 16.2969V13.5558C22.259 13.0862 21.8782 12.7054 21.4086 12.7054H13.1853ZM20.5583 15.4466H14.0356V14.4062H20.5583V15.4466Z",
    fill: "#FFBB38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocimg);
export default __webpack_public_path__ + "static/media/blocimg.684aa422b253c3bbb78fd7adeb05b063.svg";
export { ForwardRef as ReactComponent };